/** @format */

import { PromoOriginEnum } from '@shared/data-access/enums';

export interface Adjustment {
  amount: number;
  calUsageId: number;
  couponCode?: string;
  description: string;
  displayLevel: string;
  longDescription: string;
  offerCode?: string;
  priority: number;
  promotionId: string;
  usage: string;
  isFreeShipping?: boolean;
  externalPromotionId?: string;
  promoOrigin?: PromoOriginEnum;
}
